<template>
  <button
    type="button"
    @click="$emit('click')"
    class="rounded p-2 gap-2 flex items-center disabled:opacity-60"
    :class="{
      'bg-blue-600 text-white hover:bg-blue-500': color === 'blue',
      'bg-ecorus text-white': color === 'green',
      'bg-gray-600 text-white hover:bg-gray-500': color === 'gray',
    }"
  >
    <div v-show="loading">
      <Spinner class="h-4 w-4" />
    </div>
    <div><slot></slot></div>
  </button>
</template>

<script setup>
import Spinner from '@/components/shared/Spinner.vue'

defineEmits(['click'])

defineProps({
  loading: {
    type: Boolean,
  },
  color: {
    type: String,
    required: true,
    validator(value) {
      return ['green', 'gray', 'blue'].includes(value)
    },
  },
})
</script>
